angular.module('ui2.0Controllers').controller('partialResetController', ['$scope', '$uibModal', '$rootScope', '$location', '$templateCache', '$compile', '$timeout', '$http', '$window', '$anchorScroll', 'urlFactory', '$routeParams', '$sce', '$document', '$route', '$filter', '$q', function ($scope, $modal, $rootScope, $location, $templateCache, $compile, $timeout, $http, $window, $anchorScroll, urlFactory, $routeParams, $sce, $document, $route, $filter, $q) {
    $scope.optionListData = [];
    $scope.allOptionsData = [];
    $scope.checkedOptionMap = {};
    $scope.searchBox = {text:''};
    $scope.reCalculateDeviation = {
        value: false
    }
    $scope.checkedItemList = [];
    var searchTimerId;
    $scope.init = () => {
        if($scope.reOCR){
            $http.get('/autoextraction/languages/'+$scope.docId).then(function (res) {
                if(res.status == 200 && _.get(res,"data.response")){
                    $scope.allOptionsData=_.cloneDeep(res.data.response);
                    $scope.optionListData = _.cloneDeep($scope.allOptionsData);
                    _.forEach($scope.optionListData, function(value, key) {
                        if(value.selected){
                            $scope.checkedItemList.push(value);
                            $scope.checkedOptionMap[value.id]=true;
                        }
                    })
                }
            })
        }else{
            $http.get($scope.appBaseApiUrl + '/metadataautoextraction/getAllFields').then(function (res) {
                if(res.status == 200 && _.get(res,"data.response")) {
                    console.log(res)
                    $scope.allOptionsData = _.get(res,"data.response");
                    $scope.optionListData = _.cloneDeep($scope.allOptionsData);
                    setTimeout(() => {
                        if(_.get(window.checkedItemList,"length")) {
                            $scope.checkedOptionMap = window.checkedItemList.reduce((acc,item) => {
                                acc[item.id] = true;
                                return acc;
                            },{})
                            $scope.checkedItemList = _.cloneDeep(window.checkedItemList);
                            if(window.reCalculateDeviation)
                                $scope.reCalculateDeviation.value = window.reCalculateDeviation;
                            $scope.$apply();
                        }
                    },0)
                }
            });
        }
    }

    $scope.chkItems = (option) => {
        if(option && $scope.checkedOptionMap[option.id] != undefined)
            return $scope.checkedOptionMap[option.id];
        return false;
    }

    $scope.filterListData = () => {
        clearTimeout(searchTimerId);
        searchTimerId = setTimeout(() => {
            $scope.optionListData = $scope.allOptionsData.filter(o => o.name.toLowerCase().indexOf($scope.searchBox.text.toLowerCase()) > -1);
            $scope.$apply();
        },500)
    }

    $scope.itemSelected = (option,event) => {
        if(typeof event == "boolean")
            $scope.checkedOptionMap[option.id] = event;
        else $scope.checkedOptionMap[option.id] = _.get(event,"target.checked")

        let index =  $scope.checkedItemList.findIndex(o=>o.id==option.id);
        if($scope.checkedOptionMap[option.id] && index == -1) {
            $scope.checkedItemList.push(option);
        } else if(!$scope.checkedOptionMap[option.id] && index != -1) {
            $scope.checkedItemList.splice(index,1);
        }
    }

    $scope.clearAll = () => {
        $scope.checkedOptionMap = {};
        $scope.checkedItemList = [];
    }

    $scope.submit = () => {
            if($scope.docId && $scope.reCalculateDeviation.value && !_.get($scope.checkedItemList,"length")) {
                window.reCalculateDeviation = $scope.reCalculateDeviation.value;
                $scope.partialResetDialogInstance?.close();
            }else if($scope.partialResetDialogInstance && _.get($scope.checkedItemList,"length") || $scope.reCalculateDeviation.value) {
                window.checkedItemList = $scope.checkedItemList;
                window.reCalculateDeviation = $scope.reCalculateDeviation.value;
                $scope.partialResetDialogInstance?.close();
                $scope.resetAutomationDocs(null,true);
            }else if($scope.reOCRDialogInstance && _.get($scope.checkedItemList,"length") || $scope.reOCR) {
                window.checkedItemList = $scope.checkedItemList;
                $scope.resetAutomationDocs();
            }
            else {
                Toaster.create("Please select at least one Field!",{iconClass:"icon-Information_filled"});
            }

    }

    $scope.init();

}]);